<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'
  import { IconPhone } from '@gat-ship/icons'
  import { useFormatting } from '@gat-ship/utils'

  const { formatPhoneNumber } = useFormatting()
  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      iconClass?: HTMLAttributes['class']
      /** The phone number to display. */
      phoneNumber?: string
      /** The text to display when there is no phone number. @default 'No Phone Number.' */
      noPhoneNumberText?: string

      /** Whether to show the phone icon. @default false */
      showIcon?: boolean
      testId?: string
      dataTestId?: string
    }>(),
    {
      showIcon: true
    }
  )
</script>
<template>
  <a
    v-if="phoneNumber"
    :href="`tel:${phoneNumber}`"
    :class="cn('hover:text-link/80 flex items-center gap-2', props.class)"
    @click.stop
  >
    <icon-phone v-if="props.showIcon" :class="cn('size-4', props.iconClass)" />
    <span :data-testid="props.testId ?? props.dataTestId">{{
      formatPhoneNumber(phoneNumber)
    }}</span>
  </a>
  <span v-else class="text-muted-foreground">{{
    noPhoneNumberText ?? 'No Phone Number.'
  }}</span>
</template>
